import { Job } from '~extension/web2print/model/Job';
import { DownloadFormatListItem } from '~extension/web2print/view/MyFiles/DownloadFormatListItem';

type DownloadFormatListProps = {
  myFilesJob: Job;
};

export function DownloadFormatList({ myFilesJob }: DownloadFormatListProps) {
  return (
    <>
      {Object.values(myFilesJob.downloadFormats).map((downloadFormat, index) => (
        <DownloadFormatListItem
          jobId={myFilesJob.jobId}
          documentId={myFilesJob.documentId}
          clientId={myFilesJob.clientId}
          downloadFormat={downloadFormat}
          documentName={myFilesJob.documentName}
          key={index}
        />
      ))}
    </>
  );
}
